define('presentation/settings/closeAccount/presentationObjects/closeAccountNoLongerNeededFeedbackReasonPresentationObject',[],function() {
    return function(){
        let self = this;
        self.text = null;
        self.value = null;
    };
});

